import { BuyToneDto, BuyToneDtoImpl } from '../../../../core/dto/buytone/buytonedto';
import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState } from '../../../toolkit/uicomponent';
import { ToneDto } from '../../../../core/dto/tonedto';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { BuyToneCSSStyleImpl } from './buytonecss';
import { BuyToneAPIModelImpl, BuyToneAPIModel } from './buytoneapimodel';
import { BuyToneViewImpl } from './buytoneview';
import { ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { GetTonePriceDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { PopUpWrapperComponent } from '../popupwrappercomponent';
import { CreateAccountDto, CreateAccountDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto';

export interface BuyToneComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    getPopupWrapper():PopUpWrapperComponent|any;
    showPopupOption(id:string):void;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface BuyToneComponentState extends  UIComponentState
{
    isPrice: boolean;
    price:string;
    packName: string;
    msisdn: string;
    isNewUser:boolean;
    isRegisteredUser: boolean;
}

export interface BuyToneComponentHandler extends UIComponentHandler
{
    onConfirmClick(): void;
    onRequestOtpClick(): void;
}

export class BuyToneComponent extends UIComponentImpl<BuyToneComponentProps, BuyToneComponentState, BuyToneDto> 
implements BuyToneComponentHandler
{
    constructor(props: BuyToneComponentProps, state:BuyToneComponentState)
    {
        super(props);
        this.state={price: this.getContext().getConfigurationSettings().getProperty("TONE_PRICE"),
         packName: '',
          isPrice: false, msisdn: "",isNewUser:false, isRegisteredUser: false};
    }

    componentDidMount()
    {
        
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as BuyToneViewImpl).showLoader();   
            (this.getAPIModel() as BuyToneAPIModel).getTonePrice(this.props.toneDto);
        }
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<BuyToneDto>
    {
        return new BuyToneViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new BuyToneCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new BuyToneAPIModelImpl(applicationContext, apiModelHandler);
    }

    onConfirmClick(): void 
    {  
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
                (this.getView() as BuyToneViewImpl).showLoader();  
                let buyTone = new BuyToneDtoImpl();
                buyTone.setToneId(this.props.toneDto.getId());
                buyTone.setToneName(this.props.toneDto.getToneName());
                buyTone.setUserName(this.props.context.getUserContext().getUsername());
                buyTone.setChannel(this.props.context.getUserContext().getChannelId());
                buyTone.setMsisdn(this.props.context.getUserContext().getMsisdn());
                buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
                buyTone.setPackName(this.state.packName);
            
                (this.getAPIModel() as BuyToneAPIModel).buyTone(buyTone);
         
        }
        else 
        {
            //  if((this.getView() as BuyToneViewImpl).validate())
            //   {
            //     (this.getView() as BuyToneViewImpl).showLoader();  
            //     (this.getAPIModel() as BuyToneAPIModel).getTonePriceNonLoggedInuser((this.getView() as BuyToneViewImpl).getData());
            //   } 

              {
                if((this.getView() as BuyToneViewImpl).validate())
                 {
                     let msisdn = (this.getView() as BuyToneViewImpl).getData().getMsisdn();
                     this.setState({msisdn: msisdn}, () =>
                     {
                         (this.getView() as BuyToneViewImpl).showLoader();  
                         (this.getAPIModel() as BuyToneAPIModel).validateSubscriber(msisdn);
                     });
                 } 
           }
        }
    }

    onRequestOtpClick()
    {
        if(!this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as BuyToneViewImpl).showLoader();    
            if(this.state.isRegisteredUser)
            {
                (this.getAPIModel() as BuyToneAPIModel).getOTP((this.getView() as BuyToneViewImpl).getOTPData());
            }
            else
            {
                (this.getAPIModel() as BuyToneAPIModel).getSecurityCounter();
            }
        }
    }

    createAccount(createAccount: CreateAccountDto, securityToken: string): void {
        (this.getView() as BuyToneViewImpl).showLoader();

        (this.getAPIModel() as BuyToneAPIModel).createAccount(createAccount, securityToken);
    }
   
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as BuyToneViewImpl).dismissLoader();  
        if(feature === APIFeatures.GET_TONE_PRICE)
        {
            this.setState({msisdn: description, isPrice: true,
                    packName: (data as GetTonePriceDetailsDto).getPackName()});
   
                 this.setState({isNewUser: (data as GetTonePriceDetailsDto).getIsNewUser()}, () =>
                 {
                     this.onRequestOtpClick();
                 });
        }
        
        else if(feature === APIFeatures.SUBSCRIBER_VALIDATION && 
            description === this.getContext().getResources().getString(Strings.valid_subscriber))
        {
                let toneDto = this.props.toneDto;
                let request = new BuyToneDtoImpl();
                request.setToneId(toneDto.getId());
                request.setToneName(toneDto.getToneName());
                request.setLanguage(this.props.context.getUserContext().getLanguage());
                request.setMsisdn(this.state.msisdn);
                request.setUserName(this.props.context.getUserContext().getUsername());
                request.setChannel(this.props.context.getUserContext().getChannelId());
                request.setPackName(this.state.packName);

                this.setState({isRegisteredUser: true}, () =>
                {
                    (this.getView() as BuyToneViewImpl).showLoader();  
    
                    (this.getAPIModel() as BuyToneAPIModel).getTonePriceNonLoggedInuser(
                        request);
                });
          
        }
        else if(feature === APIFeatures.SECURITY_TOKEN)
        {
            let request = new CreateAccountDtoImpl();
            request.setMsisdn(this.state.msisdn);
            request.setEmail("");
            request.setLanguage(this.props.context.getUserContext().getLanguage());
            request.setPassword("Oem@L#@1");
            request.setCategoryId("4");
            
            this.createAccount(request, data);
            
        }
        else if(feature === APIFeatures.CREATE_ACCOUNT)
        {
            this.props.context.getUserContext().setMsisdnB(this.state.msisdn);
            (this.props.context.getUserContext().setSecToken((data as CreateAccountDto).getSecToc()));
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
            this.props.context.getUserContext().setIsRegisteredUser(this.state.isRegisteredUser);
            this.props.context.setUserContext(this.props.context.getUserContext());

           this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
           this.props.context.getResources().getString(Strings.otp_verification));
        }
        else if(feature === APIFeatures.BUY_TONE)
        {
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.setUserContext(this.props.context.getUserContext());
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
        }
       else  if(feature === APIFeatures.GENERATE_OTP)
        {
            this.props.context.getUserContext().setMsisdnB(this.state.msisdn);
            (this.props.context.getUserContext().setSecToken(""));
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
            this.props.context.getUserContext().setIsRegisteredUser(this.state.isRegisteredUser);
            this.props.context.setUserContext(this.props.context.getUserContext());

            this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
            this.props.context.getResources().getString(Strings.otp_verification));
        }
        else
        {
            (this.getView() as BuyToneViewImpl).dismissLoader();    
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as BuyToneViewImpl).dismissLoader();  
        if(feature === APIFeatures.BUY_TONE)
        {
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

        }
        else if(feature === APIFeatures.SUBSCRIBER_VALIDATION)
        {   
            if(description === this.getContext().getResources().getString(Strings.subscriber_not_registered))
            {
                let toneDto = this.props.toneDto;
                let request = new BuyToneDtoImpl();
                request.setToneId(toneDto.getId());
                request.setToneName(toneDto.getToneName());
                request.setLanguage(this.props.context.getUserContext().getLanguage());
                request.setMsisdn(this.state.msisdn);
                request.setUserName(this.props.context.getUserContext().getUsername());
                request.setChannel(this.props.context.getUserContext().getChannelId());
                request.setPackName(this.state.packName);

                this.setState({isRegisteredUser: false}, () =>
                {
                    (this.getView() as BuyToneViewImpl).showLoader();  
    
                    (this.getAPIModel() as BuyToneAPIModel).getTonePriceNonLoggedInuser(
                        request);
                });
            }
            else
            {
                this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   
            }
        }
        else
        {
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   
        }
    }            
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytonecomponent.tsx